(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fabrix-color-rail"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('fx-color-rail')) return;
    class FxColorRail extends HTMLElement {
      connectedCallback() {
        const R = window.FabrixRenk;
        if (R) {
          R.init(this.dataset.renk, { hex: this.dataset.hex, ad: this.dataset.ad });
          this.fillName();
        }
        this.rail = this.querySelector('[data-rail]');
        this.onClick = (e) => {
          const b = e.target.closest('[data-dir]');
          if (!b || !this.rail) return;
          const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.rail.scrollBy({ left: Number(b.dataset.dir) * this.rail.clientWidth * 0.8, behavior: reduce ? 'auto' : 'smooth' });
        };
        this.addEventListener('click', this.onClick);
      }
      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
      }
      // Oturumda başka renk kayıtlıysa adını kartların verisinden bulur (FabrixRenk.init bu durumda adı yazmaz).
      fillName() {
        const R = window.FabrixRenk;
        if (R.ad && R.ad.length) return;
        for (const s of this.querySelectorAll('[data-fx-json]')) {
          const d = R.data(s);
          const v = d && R.match(d.variants, R.current);
          if (v) {
            const hex = v.sw && v.sw.charAt(0) === '#' ? v.sw : undefined;
            R.apply({ hex, ad: v.renk });
            return;
          }
        }
      }
    }
    customElements.define('fx-color-rail', FxColorRail);
    // Kartlardaki "<Renk> rengi yok" etiketleri sayfa sonunda da doldurulsun.
    const refill = () => {
      const R = window.FabrixRenk;
      if (R && R.ad) R.apply({ ad: R.ad });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refill);
    else refill();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fabrix-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('fx-hero')) return;
    const W = (url, w) => (url ? url.replace(/([?&])width=\d+/, '$1width=' + w) : url);
    const SRCSET = (url) => [750, 1100, 1500, 1800, 2400].map((w) => W(url, w) + ' ' + w + 'w').join(', ');

    class FxHero extends HTMLElement {
      connectedCallback() {
        const R = window.FabrixRenk;
        if (!R) return;
        this.p = R.data(this.querySelector('[data-fx-json]'));
        const altEl = this.querySelector('[data-fx-json-alt]');
        this.alt = altEl ? R.data(altEl) : null;
        if (!this.p) return;
        const def = this.dataset.renk;
        const v0 = R.match(this.p.variants, def);
        const cur = R.init(def, v0 ? { hex: v0.sw, ad: v0.renk } : {});
        this.shown = def;
        this.onRenk = (e) => this.update(e.detail.slug, true);
        document.addEventListener('fabrix:renk', this.onRenk);
        this.querySelector('[data-look-add]')?.addEventListener('click', (e) => this.add(e.currentTarget));
        this.querySelector('[data-hero-scroll]')?.addEventListener('click', (e) => this.scroll(e));
        if (cur && cur !== def) {
          const v = R.match(this.p.variants, cur) || (this.alt && R.match(this.alt.variants, cur));
          if (v) R.apply({ hex: v.sw, ad: v.renk });
          this.update(cur, false);
        }
      }

      disconnectedCallback() {
        document.removeEventListener('fabrix:renk', this.onRenk);
      }

      update(slug, animate) {
        if (!slug || slug === this.shown) return;
        this.shown = slug;
        const R = window.FabrixRenk;
        const v = R.match(this.p.variants, slug);
        const sv = v || (this.alt && R.match(this.alt.variants, slug));
        if (sv && sv.sahne) this.swap(sv, animate);

        const go = this.querySelector('[data-hero-go]');
        if (go) go.href = this.p.url + (v ? '?variant=' + v.id : '');

        const look = this.querySelector('[data-look]');
        if (!look) return;
        look.hidden = !v;
        if (!v) return;
        this.lookVariant = v;
        const img = look.querySelector('[data-look-img]');
        if (img && v.img) { img.removeAttribute('srcset'); img.src = W(v.img, 200); }
        const meta = [v.renk];
        const setKisa = (this.p.set || '').split(',')[0].trim();
        if (setKisa) meta.push(setKisa);
        if (this.p.olcu) meta.push(this.p.olcu);
        look.querySelector('[data-look-meta]').textContent = meta.join(' · ');
        look.querySelector('[data-look-price]').textContent = R.money(v.price);
        const btn = look.querySelector('[data-look-add]');
        if (btn) btn.disabled = !v.available;
      }

      swap(v, animate) {
        const a = this.querySelector('[data-hero-a]');
        const b = this.querySelector('[data-hero-b]');
        if (!a || !b) return;
        const [front, back] = a.classList.contains('is-out') ? [b, a] : [a, b];
        back.sizes = '100vw';
        back.srcset = SRCSET(v.sahne);
        back.src = v.sahne;
        back.alt = v.renk + ' örgü supla ile kurulmuş sofra';
        const go = () => { back.classList.remove('is-out'); front.classList.add('is-out'); };
        if (!animate) return go();
        back.decode ? back.decode().then(go, go) : go();
      }

      async add(btn) {
        const R = window.FabrixRenk;
        const v = this.lookVariant || R.match(this.p.variants, R.current) || R.match(this.p.variants, this.dataset.renk);
        if (!v || !window.FabrixCart) return;
        btn.setAttribute('aria-busy', 'true');
        try { await window.FabrixCart.addLines([{ id: v.id, quantity: 1 }], 'fabrix-hero'); }
        catch (err) { console.error(err); }
        finally { btn.removeAttribute('aria-busy'); }
      }

      scroll(e) {
        const href = e.currentTarget.getAttribute('href') || '';
        if (!href.startsWith('#')) return;
        const target = document.getElementById(href.slice(1));
        if (!target) return;
        e.preventDefault();
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth' });
      }
    }
    customElements.define('fx-hero', FxHero);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fabrix-kategoriler"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('fx-kategoriler')) return;
    class FxKategoriler extends HTMLElement {
      connectedCallback() {
        this.list = this.querySelector('[data-list]');
        this.bar = this.querySelector('[data-bar]');
        this.fill = this.querySelector('[data-fill]');
        this.nav = this.querySelector('[data-nav]');
        if (!this.list) return;
        this.onScroll = () => { if (!this.raf) this.raf = requestAnimationFrame(() => { this.raf = 0; this.update(); }); };
        this.list.addEventListener('scroll', this.onScroll, { passive: true });
        this.ro = new ResizeObserver(this.onScroll);
        this.ro.observe(this.list);
        this.addEventListener('click', (e) => {
          const b = e.target.closest('[data-dir]');
          if (!b) return;
          const still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.list.scrollBy({ left: Number(b.dataset.dir) * this.list.clientWidth * 0.8, behavior: still ? 'auto' : 'smooth' });
        });
        this.update();
      }
      disconnectedCallback() {
        if (this.ro) this.ro.disconnect();
        if (this.list) this.list.removeEventListener('scroll', this.onScroll);
      }
      update() {
        const l = this.list;
        const max = l.scrollWidth - l.clientWidth;
        const tasar = max > 2;
        this.classList.toggle('is-tasar', tasar);
        this.classList.toggle('is-bas', l.scrollLeft <= 2);
        this.classList.toggle('is-son', l.scrollLeft >= max - 2);
        if (this.nav) {
          this.nav.hidden = !tasar;
          const [geri, ileri] = this.nav.querySelectorAll('button');
          if (geri) geri.disabled = l.scrollLeft <= 2;
          if (ileri) ileri.disabled = l.scrollLeft >= max - 2;
        }
        if (this.bar) {
          this.bar.hidden = !tasar;
          if (tasar) {
            const oran = l.clientWidth / l.scrollWidth;
            const bos = (1 - oran) * this.bar.clientWidth;
            this.fill.style.setProperty('--kat-w', `${oran * 100}%`);
            this.fill.style.setProperty('--kat-x', `${(l.scrollLeft / max) * bos}px`);
          }
        }
      }
    }
    customElements.define('fx-kategoriler', FxKategoriler);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fabrix-prayer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('fx-prayer')) return;
    const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
    const key = (u) => (u ? String(u).split('?')[0] : '');
    const sized = (u, w) => (u ? String(u).replace(/width=\d+/, 'width=' + w) : u);
    const still = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    class FxPrayer extends HTMLElement {
      connectedCallback() {
        this.D = window.FabrixRenk && window.FabrixRenk.data(this.querySelector('[data-fx-prayer-json]'));
        if (!this.D) return;
        this.h = this.dataset.cur;
        this.slug = null;
        this.addEventListener('click', (e) => this.onClick(e));
      }

      state() {
        const P = this.D[this.h];
        const vs = P.product.variants;
        const v = vs.find((x) => x.slug === this.slug) || vs[0];
        const photo = P.scenes[v.slug] || v.sahne || P.mood || v.img;
        return { P, v, photo };
      }

      render() {
        const { P, v, photo } = this.state();
        const p = P.product;
        const segs = Object.keys(this.D)
          .map((k) => `<button type="button" aria-pressed="${k === this.h}" data-sec="${k}">${esc(this.D[k].ad)}</button>`)
          .join('');
        const sws = p.variants
          .map((x) => `<button type="button" class="fx-sw"${x.img ? ` style="background:url('${sized(x.img, 120)}') center/cover"` : ''} aria-label="${esc(x.renk)}" title="${esc(x.renk)}" aria-pressed="${x === v}" data-slug="${esc(x.slug)}"></button>`)
          .join('');
        const thumbs = P.thumbs
          .filter((t) => key(t) !== key(photo))
          .slice(0, 2)
          .map((t) => `<img src="${t}" alt="" loading="lazy">`)
          .join('');
        this.querySelector('[data-body]').innerHTML = `<p class="fx-prayer__p">${esc(P.p)}</p>
          <div class="fx-seg" role="group" aria-label="Seccade türü">${segs}</div>
          <p class="fx-step">Desen <b>${esc(v.renk)}</b></p>
          <div class="fx-picker" role="group" aria-label="Desen seçin">${sws}</div>
          <div class="fx-prayer__buy">${v.img ? `<img src="${sized(v.img, 168)}" alt="" width="56" height="84">` : '<span></span>'}<div><b>${esc(p.title)}</b><small>${esc(P.olcu)}</small></div><span>${window.FabrixRenk.money(v.price)}</span></div>
          <div class="fx-prayer__ctas"><button type="button" class="fx-btn fx-btn--light" data-add${v.available ? '' : ' disabled'}>Sepete ekle</button><a class="fx-link" href="${p.url}?variant=${v.id}">Ürünü incele</a><a class="fx-link" href="${esc(this.dataset.all)}">Tüm seccadeler</a></div>
          <div class="fx-prayer__thumbs">${thumbs}</div>`;
        this.swap(photo, p.title);
      }

      swap(src, title) {
        const im = this.querySelector('[data-photo]');
        if (!im || !src || key(im.currentSrc || im.src) === key(src)) return;
        const go = () => {
          im.removeAttribute('srcset');
          im.removeAttribute('sizes');
          im.onload = () => (im.style.opacity = 1);
          im.src = src;
          im.alt = `${title}, kullanım sahnesi`;
        };
        if (still()) return go();
        im.style.opacity = 0;
        setTimeout(go, 220);
      }

      async onClick(e) {
        const seg = e.target.closest('[data-sec]');
        if (seg) {
          if (seg.dataset.sec === this.h) return;
          this.h = seg.dataset.sec;
          this.slug = null;
          this.render();
          const again = this.querySelector(`[data-sec="${this.h}"]`);
          if (again) again.focus();
          return;
        }
        const sw = e.target.closest('.fx-picker .fx-sw');
        if (sw) {
          this.slug = sw.dataset.slug;
          this.render();
          const again = this.querySelector(`.fx-picker [data-slug="${sw.dataset.slug}"]`);
          if (again) again.focus();
          return;
        }
        const add = e.target.closest('[data-add]');
        if (add) {
          const { v } = this.state();
          add.setAttribute('aria-busy', 'true');
          try { await window.FabrixCart.addLines([{ id: v.id, quantity: 1 }], 'fabrix-prayer'); }
          catch (err) { console.error(err); }
          finally { add.removeAttribute('aria-busy'); }
        }
      }
    }
    customElements.define('fx-prayer', FxPrayer);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fabrix-related"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('fx-related')) return;
    class FxRelated extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', (e) => {
          const b = e.target.closest('[data-dir]');
          const rail = this.querySelector('[data-rail]');
          if (!b || !rail) return;
          const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          rail.scrollBy({ left: Number(b.dataset.dir) * rail.clientWidth * 0.8, behavior: reduce ? 'auto' : 'smooth' });
        });
        if (!this.dataset.url) return;
        const io = new IntersectionObserver((entries) => {
          if (!entries.some((x) => x.isIntersecting)) return;
          io.disconnect();
          this.load();
        }, { rootMargin: '0px 0px 400px 0px' });
        io.observe(this);
      }
      async load() {
        try {
          const res = await fetch(this.dataset.url);
          if (!res.ok) return;
          const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
          const yeni = doc.querySelector('fx-related [data-rail]');
          // Öneri boş dönerse koleksiyon rafı kalır
          if (!yeni || !yeni.children.length) return;
          this.querySelector('[data-rail]').replaceWith(yeni);
          this.querySelector('[data-bos]')?.remove();
        } catch (e) {}
      }
    }
    customElements.define('fx-related', FxRelated);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fabrix-scene"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('fx-scene')) return;
    class FxScene extends HTMLElement {
      connectedCallback() {
        const R = window.FabrixRenk;
        this.data = R && R.data(this.querySelector('[data-fx-json]'));
        if (!this.data || !this.data.variants.length) return;
        const vs = this.data.variants;
        R.init(this.dataset.renk);
        const sabit = this.hasAttribute('data-sabit');
        this.cur = sabit ? vs.find((x) => String(x.id) === this.dataset.v) || vs[0] : R.match(vs, R.current) || vs.find((x) => x.sahne) || vs[0];
        if (String(this.cur.id) !== this.dataset.v) this.update(false);
        if (sabit) { this.onClick = (e) => this.click(e); this.addEventListener('click', this.onClick); return; }
        this.onRenk = (e) => {
          const v = window.FabrixRenk.match(this.data.variants, e.detail.slug);
          if (v && v !== this.cur) { this.cur = v; this.update(true); }
        };
        document.addEventListener('fabrix:renk', this.onRenk);
        this.onClick = (e) => this.click(e);
        this.addEventListener('click', this.onClick);
      }
      disconnectedCallback() {
        if (this.onRenk) document.removeEventListener('fabrix:renk', this.onRenk);
        if (this.onClick) this.removeEventListener('click', this.onClick);
      }
      async click(e) {
        const sw = e.target.closest('[data-picker] [data-v]');
        if (sw) {
          const v = this.data.variants.find((x) => String(x.id) === sw.dataset.v);
          if (v && v !== this.cur) { this.cur = v; this.update(true); }
          return;
        }
        const add = e.target.closest('[data-add]');
        if (add && !add.disabled) {
          add.setAttribute('aria-busy', 'true');
          try { await window.FabrixCart.addLines([{ id: this.cur.id, quantity: 1 }], 'fabrix-scene'); }
          catch (err) { console.error(err); }
          finally { add.removeAttribute('aria-busy'); }
        }
      }
      update(fade) {
        const v = this.cur;
        const d = this.data;
        const R = window.FabrixRenk;
        this.dataset.v = v.id;
        const ad = this.querySelector('[data-renk-ad]');
        if (ad) ad.textContent = v.renk;
        this.querySelectorAll('[data-picker] [data-v]').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.v === String(v.id))));
        const th = this.querySelector('[data-thumb]');
        if (th && v.img) { th.removeAttribute('srcset'); th.src = v.img; }
        const pr = this.querySelector('[data-price]');
        if (pr) pr.textContent = v.price ? R.money(v.price) : 'Fiyat yakında';
        const add = this.querySelector('[data-add]');
        if (add) {
          add.disabled = !v.price || !v.available;
          add.textContent = !v.price ? 'Yakında' : !v.available ? 'Tükendi' : 'Sepete ekle';
        }
        const link = this.querySelector('[data-link]');
        if (link) link.href = `${d.url}?variant=${v.id}`;
        const im = this.querySelector('[data-img]');
        const src = v.sahne || v.img;
        if (!im || !src) return;
        const swap = () => {
          im.removeAttribute('srcset');
          im.src = src;
          im.alt = `${d.title}, ${v.renk}, kullanım sahnesi`;
        };
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (!fade || reduce) return swap();
        im.style.opacity = 0;
        clearTimeout(this.t);
        this.t = setTimeout(() => {
          im.onload = () => (im.style.opacity = 1);
          swap();
          if (im.complete) im.style.opacity = 1;
        }, 220);
      }
    }
    customElements.define('fx-scene', FxScene);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fabrix-set-builder"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('fx-set-builder')) return;
    const esc = (t) => String(t == null ? '' : t).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
    const W = (url, w) => (url ? url.replace(/([?&])width=\d+/, '$1width=' + w) : url);

    class FxSetBuilder extends HTMLElement {
      connectedCallback() {
        const R = window.FabrixRenk;
        if (!R) return;
        this.P = {};
        this.querySelectorAll('[data-fx-p]').forEach((el) => (this.P[el.dataset.fxP] = R.data(el)));
        this.shape = this.dataset.start === 'oval' && this.P.oval ? 'oval' : this.P.supla ? 'supla' : 'oval';
        this.skip = {};
        const def = this.dataset.renk;
        const v0 = this.colorVariant(def);
        this.color = R.init(def, v0 ? { hex: v0.sw, ad: v0.renk } : {}) || def;
        if (this.color !== def) {
          const v = this.colorVariant(this.color);
          if (v) R.apply({ hex: v.sw, ad: v.renk });
          this.media(false);
        }
        this.render();

        this.onRenk = (e) => { if (e.detail.slug === this.color) return; this.color = e.detail.slug; this.media(true); this.render(); };
        document.addEventListener('fabrix:renk', this.onRenk);
        this.addEventListener('click', (e) => this.onClick(e));
        this.addEventListener('change', (e) => {
          const k = e.target.dataset && e.target.dataset.skip;
          if (!k) return;
          this.skip[k] = !e.target.checked;
          this.render();
        });
      }

      disconnectedCallback() {
        document.removeEventListener('fabrix:renk', this.onRenk);
      }

      pick(key, slug = this.color) {
        const p = this.P[key];
        if (!p) return null;
        const v = window.FabrixRenk.match(p.variants, slug);
        return v && v.available ? v : null;
      }

      colorVariant(slug) {
        const R = window.FabrixRenk;
        return (this.P.supla && R.match(this.P.supla.variants, slug)) || (this.P.oval && R.match(this.P.oval.variants, slug)) || null;
      }

      colors() {
        const R = window.FabrixRenk;
        const round = this.P.supla ? this.P.supla.variants : [];
        const oval = this.P.oval ? this.P.oval.variants.filter((o) => !R.match(round, o.slug)) : [];
        return round.concat(oval);
      }

      items() {
        return [[this.shape, 'supla'], ['altlik', 'altlik'], ['kase', 'kase']]
          .filter(([key]) => this.P[key])
          .map(([key, k]) => ({ key, k, p: this.P[key], v: this.pick(key) }));
      }

      media(fade) {
        const img = this.querySelector('[data-bimg]');
        const sv = this.pick(this.shape) || (this.P[this.shape] && window.FabrixRenk.match(this.P[this.shape].variants, this.color));
        if (!img || !sv || !sv.sahne) return;
        if (img.dataset.src === sv.sahne) return;
        img.dataset.src = sv.sahne;
        const swap = () => {
          img.removeAttribute('srcset');
          img.src = W(sv.sahne, 1800);
          img.onload = () => (img.style.opacity = 1);
        };
        if (!fade) return swap();
        img.style.opacity = 0;
        setTimeout(swap, 250);
      }

      render() {
        const R = window.FabrixRenk;
        const ds = this.dataset;
        const items = this.items();
        const on = items.filter((i) => i.v && !this.skip[i.k]);
        const sum = on.reduce((a, i) => a + i.v.price, 0);
        this.on = on;

        this.querySelectorAll('[data-shape]').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.shape === this.shape)));

        const picker = this.querySelector('[data-picker]');
        if (picker) {
          const shapeVariants = this.P[this.shape] ? this.P[this.shape].variants : [];
          picker.innerHTML = this.colors().map((x) => {
            const na = R.match(shapeVariants, x.slug) ? '' : ' is-na';
            return `<button type="button" class="fx-sw${na}" style="--c:${esc(x.sw)};background:${esc(x.sw)}" aria-label="${esc(x.renk)}" aria-pressed="${x.slug === this.color}" title="${esc(x.renk)}" data-slug="${esc(x.slug)}" data-hex="${esc(x.sw)}" data-ad="${esc(x.renk)}"></button>`;
          }).join('');
        }

        const rows = this.querySelector('[data-rows]');
        if (rows) {
          rows.innerHTML = items.map((i) => {
            if (i.v) {
              const off = this.skip[i.k];
              const meta = [i.v.renk, i.p.olcu].filter(Boolean).join(' · ');
              return `<label class="fx-builder__row${off ? ' is-off' : ''}"><input type="checkbox" ${off ? '' : 'checked'} data-skip="${i.k}"><img src="${esc(W(i.v.img, 200))}" alt="" width="72" height="72" loading="lazy"><span><b>${esc(i.p.title)}</b><small>${esc(meta)}</small></span><span>${R.money(i.v.price)}</span></label>`;
            }
            const first = i.p.variants[0] || {};
            return `<div class="fx-builder__row is-off"><span></span><img src="${esc(W(first.img, 200))}" alt="" width="72" height="72" loading="lazy"><span><b>${esc(i.p.title)}</b><small class="fx-na">${esc(ds.na)}</small></span><span></span></div>`;
          }).join('');
        }

        const n = on.length;
        const label = this.querySelector('[data-total-label]');
        if (label) label.textContent = n ? (ds.total || '').replace('[n]', n) : 'Seçili parça yok';
        const total = this.querySelector('[data-total-sum]');
        if (total) total.textContent = n ? R.money(sum) : '';
        const btn = this.querySelector('[data-add-set]');
        if (btn) {
          btn.textContent = n ? (ds.button || '').replace('[n]', n) : 'Parça seçin';
          if (btn.getAttribute('aria-busy') !== 'true') btn.disabled = !n;
        }
      }

      async onClick(e) {
        const seg = e.target.closest('[data-shape]');
        if (seg && seg.tagName === 'BUTTON') {
          if (seg.dataset.shape === this.shape) return;
          this.shape = seg.dataset.shape;
          this.render();
          this.media(false);
          return;
        }
        const btn = e.target.closest('[data-add-set]');
        if (!btn || btn.disabled || !window.FabrixCart) return;
        const lines = (this.on || []).map((i) => ({ id: i.v.id, quantity: 1 }));
        if (!lines.length) return;
        btn.setAttribute('aria-busy', 'true');
        btn.disabled = true;
        try { await window.FabrixCart.addLines(lines, 'fabrix-set-builder'); }
        catch (err) { console.error(err); }
        finally { btn.removeAttribute('aria-busy'); btn.disabled = !(this.on || []).length; }
      }
    }
    customElements.define('fx-set-builder', FxSetBuilder);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fabrix-story"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('fx-story')) return;
    class FxStory extends HTMLElement {
      connectedCallback() {
        const R = window.FabrixRenk;
        const s = this.querySelector('[data-fx-variants]');
        this.link = this.querySelector('[data-link]');
        if (!R || !s || !this.link) return;
        this.variants = R.data(s) || [];
        R.init(this.dataset.renk);
        this.onRenk = (e) => this.update(e.detail.slug);
        document.addEventListener('fabrix:renk', this.onRenk);
        this.update(R.current);
      }
      disconnectedCallback() {
        if (this.onRenk) document.removeEventListener('fabrix:renk', this.onRenk);
      }
      update(slug) {
        const v = window.FabrixRenk.match(this.variants, slug);
        const base = this.link.dataset.base;
        this.link.href = v ? `${base}?variant=${v.id}` : base;
      }
    }
    customElements.define('fx-story', FxStory);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fabrix-videolar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('fx-videolar')) return;
    class FxVideolar extends HTMLElement {
      connectedCallback() {
        this.kartlar = [...this.querySelectorAll('[data-i]')];
        this.lb = this.querySelector('[data-lb]');
        this.lbv = this.querySelector('[data-lb-v]');
        this.addEventListener('click', (e) => this.onClick(e));
        this.lb.addEventListener('close', () => { this.lbv.pause(); this.lbv.removeAttribute('src'); this.lbv.load(); this.acik = false; this.gorunenler(); });
        this.lb.addEventListener('click', (e) => { if (e.target === this.lb) this.lb.close(); });
        this.lb.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowLeft') this.git(-1);
          if (e.key === 'ArrowRight') this.git(1);
        });
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        this.io = new IntersectionObserver((entries) => {
          entries.forEach((x) => { x.target.dataset.gorunur = x.isIntersecting ? '1' : ''; });
          this.gorunenler();
        }, { threshold: 0.6 });
        this.kartlar.forEach((k) => {
          const v = k.querySelector('video');
          v.addEventListener('error', () => { if (v.src && v.src !== k.dataset.src) { v.src = k.dataset.src; this.gorunenler(); } });
          this.io.observe(k);
        });
      }
      disconnectedCallback() { if (this.io) this.io.disconnect(); }

      // Şeritte yalnız görünen videolar oynar; tam ekran açıkken hepsi durur
      gorunenler() {
        this.kartlar.forEach((k) => {
          const v = k.querySelector('video');
          if (k.dataset.gorunur && !this.acik) {
            if (!v.src) v.src = v.dataset.src;
            v.play().catch(() => {});
          } else v.pause();
        });
      }

      onClick(e) {
        const b = e.target.closest('[data-dir]');
        if (b) {
          const rail = this.querySelector('[data-rail]');
          const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          rail.scrollBy({ left: Number(b.dataset.dir) * rail.clientWidth * 0.8, behavior: reduce ? 'auto' : 'smooth' });
          return;
        }
        if (e.target.closest('[data-lb-x]')) return this.lb.close();
        const ok = e.target.closest('[data-lb-dir]');
        if (ok) return this.git(Number(ok.dataset.lbDir));
        const k = e.target.closest('[data-i]');
        if (k) this.ac(Number(k.dataset.i));
      }

      ac(i) {
        this.i = i;
        this.acik = true;
        this.gorunenler();
        const k = this.kartlar[i];
        this.lbv.poster = k.querySelector('video').poster;
        this.lbv.src = k.dataset.src;
        this.lbv.muted = false;
        this.lbv.setAttribute('aria-label', k.getAttribute('aria-label').replace(', sesli izle', ''));
        if (!this.lb.open) this.lb.showModal();
        this.lbv.play().catch(() => {});
      }

      git(d) { this.ac((this.i + d + this.kartlar.length) % this.kartlar.length); }
    }
    customElements.define('fx-videolar', FxVideolar);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fabrix-yorumlar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('fx-yorumlar')) return;
    const ALIAS = { ekru: 'beyaz', beyaz: 'ekru' };
    class FxYorumlar extends HTMLElement {
      connectedCallback() {
        this.ilk = Number(this.dataset.ilk) || 6;
        this.acik = false;
        this.r = '';
        this.k = '';
        this.vurgu = '';
        this.kartlar = [...this.querySelectorAll('.fx-yor__kart')];
        this.fotolar = (window.FabrixRenk && window.FabrixRenk.data(this.querySelector('[data-fotolar]'))) || [];
        this.lb = this.querySelector('[data-lb]');
        if (this.lb) this.lbKur();
        this.addEventListener('click', (e) => {
          const ft = e.target.closest('.fx-yor__foto');
          if (ft) {
            const i = ft.dataset.foto != null ? Number(ft.dataset.foto) : this.fotolar.findIndex((x) => x.src === ft.dataset.src);
            this.ac(Math.max(0, i), ft);
            return;
          }
          const kf = e.target.closest('[data-kfiltre] button');
          if (kf) { this.k = kf.dataset.k; this.acik = false; this.render(); return; }
          const f = e.target.closest('[data-filtre] button');
          if (f) { this.r = f.dataset.r; this.acik = false; this.render(); return; }
          if (e.target.closest('[data-daha]')) { this.acik = true; this.render(); }
        });
        this.onVar = (e) => { this.vurgu = (e.detail && e.detail.slug) || ''; if (!this.r) this.render(); };
        document.addEventListener('fabrix:pdp-variant', this.onVar);
        const sec = document.querySelector('[data-fx-sws] .fx-sw[aria-pressed="true"]');
        if (sec) this.vurgu = sec.dataset.slug || '';
        this.render();
      }
      disconnectedCallback() { document.removeEventListener('fabrix:pdp-variant', this.onVar); }
      lbKur() {
        const lb = this.lb;
        lb.addEventListener('click', (e) => {
          if (e.target.closest('[data-lb-x]') || e.target === lb || e.target.classList.contains('fx-yor__lb-in')) return lb.close();
          const d = e.target.closest('[data-lb-dir]');
          if (d) this.git(Number(d.dataset.lbDir));
        });
        lb.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowLeft') this.git(-1);
          if (e.key === 'ArrowRight') this.git(1);
        });
        let x0 = null;
        lb.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; }, { passive: true });
        lb.addEventListener('touchend', (e) => {
          if (x0 == null) return;
          const dx = e.changedTouches[0].clientX - x0; x0 = null;
          if (Math.abs(dx) > 40) this.git(dx < 0 ? 1 : -1);
        });
        lb.addEventListener('close', () => { document.documentElement.style.overflow = ''; if (this.donus) this.donus.focus(); });
      }
      ac(i, kaynak) {
        if (!this.lb || !this.fotolar.length) return;
        this.donus = kaynak;
        this.i = i;
        this.goster();
        document.documentElement.style.overflow = 'hidden';
        this.lb.showModal();
      }
      git(d) {
        const n = this.fotolar.length;
        this.i = (this.i + d + n) % n;
        this.goster();
      }
      goster() {
        const f = this.fotolar[this.i];
        const esc = (s) => String(s || '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
        const img = this.lb.querySelector('[data-lb-img]');
        img.src = f.src + '&width=1200';
        img.alt = `Müşteri fotoğrafı${f.renk ? ', ' + f.renk : ''}`;
        this.lb.querySelector('[data-lb-cap]').innerHTML = `<b>${esc(f.ad)}</b>${f.renk ? ' · Renk: ' + esc(f.renk) : ''} · ${esc(f.tarih)}<br>“${esc(f.metin)}”`;
        this.lb.querySelector('[data-lb-n]').textContent = `${this.i + 1} / ${this.fotolar.length}`;
        this.lb.querySelectorAll('[data-lb-dir]').forEach((b) => (b.hidden = this.fotolar.length < 2));
      }
      es(a, b) { return a === b || ALIAS[a] === b; }
      render() {
        const liste = this.querySelector('[data-kartlar]');
        // Filtre yokken seçili rengin yorumları öne alınır ve ince bakır çizgiyle işaretlenir
        const sira = this.kartlar
          .filter((k) => (!this.r || this.es(k.dataset.r, this.r)) && (!this.k || k.dataset.k === this.k))
          .sort((a, b) => (this.vurgu ? Number(this.es(b.dataset.r, this.vurgu)) - Number(this.es(a.dataset.r, this.vurgu)) : 0));
        this.kartlar.forEach((k) => { k.hidden = true; k.classList.toggle('is-vurgu', !this.r && !!this.vurgu && this.es(k.dataset.r, this.vurgu)); });
        sira.forEach((k, i) => { liste.appendChild(k); k.hidden = !this.acik && i >= this.ilk; });
        this.querySelectorAll('[data-filtre] button').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.r === this.r)));
        this.querySelectorAll('[data-kfiltre] button').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.k === this.k)));
        const daha = this.querySelector('.fx-yor__daha');
        if (daha) daha.hidden = this.acik || sira.length <= this.ilk;
        const bos = this.querySelector('[data-bos]');
        if (bos) bos.hidden = sira.length > 0;
      }
    }
    customElements.define('fx-yorumlar', FxYorumlar);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
